export const AuthEdat17 = ({ edat } ) => {

    {/* Avís per als que han de fer 18 anys durant el curs */}

    if(edat !== 17) return (<></>)

    return (<>
        <div className="row">
            <div className="col col-12 ">
                <h4>
                    Consentiment menors
                </h4>
                <p>
                    Les autoritzacions i el consentiment de seguiment tutorial per part de la família, implícit en el cas dels menors d'edat, tenen validesa durant tot el curs encara que l'alumnat compleixi 18 anys durant el mateix. <br />
                    L'alumnat pot exercir el seu dret de majoria d'edat signant noves autoritzacions a través de la tutoria.
                </p>

            </div>
        </div>
        <br />
    </>)

                    
}